import React, { useState, useEffect } from "react";
import "../scss/_ourTeam.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const OurTeam = () => {
    const { t, i18n } = useTranslation();
    const membersData = i18n.getResourceBundle(
        i18n.language,
        "membersTranslationContainer"
    ).membersTranslation;

    return (
        <div className="ourTeamContainer">
            <div className="title">{t("ourTeam")}</div>
            <div className="teamContainer">
                <Members memberData={membersData} />
            </div>
        </div>
    );
};

const Members = ({ memberData }) => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 500);
    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {
        const updateMedia = () => {
            setIsDesktop(window.innerWidth > 600);
        };

        window.addEventListener("resize", updateMedia);
        return () => {
            window.removeEventListener("resize", updateMedia);
        };
    }, []);

    useEffect(() => {
        const slicedData = memberData.slice(0, 6);
        setDisplayData(isDesktop ? memberData : slicedData);
    }, [memberData, isDesktop]);

    return (
        <>
            {displayData.map((member, i) => (
                <Link to={`/Team/${member.id}`} className="memberBox" key={i}>
                    <img
                        className="memberImage"
                        alt={member.alt}
                        src={require(`../assets/${member.src}`)}
                    ></img>
                    <div className="memberName">
                        {member.fName + " " + member.lName}
                    </div>
                    <div className="memberTitle">{member.degree}</div>
                </Link>
            ))}
        </>
    );
};

export default OurTeam;
